"use client";
import styled from "../../../client-utils/styled/index.js";
import ToggleListCheckmark from "../../../components/molecules/ToggleListCheckmark/index.js";
import { toggleButtonGroupClasses } from "../../../components/atoms/ToggleButtonGroup/index.js";
const coreComponentName = "SdbProfileMenuToggle";
export const Root = styled(ToggleListCheckmark, {
    name: coreComponentName,
    slot: "ToggleList",
})({
    borderRadius: 0,
    width: "100%",
    [`& .${toggleButtonGroupClasses.firstButton},& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]: {
        border: 0,
        borderRadius: "8px",
        fontSize: "1rem",
        fontWeight: "normal",
        margin: 0,
        minHeight: "56px",
    },
});
